// This class enables modifying the Element theme on the fly, something that does not seem to be
// supported in any official way. Currently only supports changing primary color.
// This code is a bit icky and could very well stop working when updating Element to a new version

// Default primary color: #409EFF = rgb(64, 158, 255)
const PRIMARY_COLOR = '#409eff';

var CHANGE_COLORS_FROM = [];
var CHANGE_COLORS_FROM_RGB = [];
var CHANGE_COLORS_TO = [];

export class ElementThemeHandler {
  ElementThemeHandler() {
    this.themeOverrideStyle = null;
    this.cssOverrideTextOriginal = '';
  }

  initElementStyleOverride(theme) {
    // create original color arrays
    this.CHANGE_COLORS_FROM = this.createColorArray(PRIMARY_COLOR);
    this.CHANGE_COLORS_FROM_RGB = [];
    for (var k = 0; k < this.CHANGE_COLORS_FROM.length; k++) {
      this.CHANGE_COLORS_FROM_RGB.push(this.toRgbFunction(this.CHANGE_COLORS_FROM[k]));
    }

    // create the css text template
    var cssText = '';
    for (var i = 0; i < document.styleSheets.length; i++) {
      var rules = document.styleSheets[i].rules || document.styleSheets[i].cssRules;
      for (var j = 0; j < rules.length; j++) {
        var rule = rules[j];
        for (var k = 0; k < this.CHANGE_COLORS_FROM_RGB.length; k++) {
          if (rule.cssText.indexOf(this.CHANGE_COLORS_FROM_RGB[k]) != -1) {
            cssText += rule.cssText + "\n";
            break;
          }
        }
      }
    }
    this.cssOverrideTextOriginal = cssText;

    // create the style override element and add to document head
    this.updateElementStyleOverride(theme);
  }

  updateElementStyleOverride(theme) {
    this.CHANGE_COLORS_TO = this.createColorArray(theme.audienceDisplayResultsAndSelectionsColor);

    if (this.themeOverrideStyle != null) {
      document.head.removeChild(this.themeOverrideStyle);
      this.themeOverrideStyle = null;
    }

    this.themeOverrideStyle = document.createElement('style');
    this.themeOverrideStyle.innerText = this.getModifiedCssText(this.cssOverrideTextOriginal);
    document.head.appendChild(this.themeOverrideStyle);
  }

  // create an array with different shades of the primary color
  // "primary": primary color
  // "shade-1": "color(primary shade(10%))",
  // "light-1": "color(primary tint(10%))",
  // "light-2": "color(primary tint(20%))",
  // "light-3": "color(primary tint(30%))",
  // "light-4": "color(primary tint(40%))",
  // "light-5": "color(primary tint(50%))",
  // "light-6": "color(primary tint(60%))",
  // "light-7": "color(primary tint(70%))",
  // "light-8": "color(primary tint(80%))",
  // "light-9": "color(primary tint(90%))"
  createColorArray(primary_color) {
    var arr = [];
    arr.push(primary_color);
    arr.push(this.colorLuminance(primary_color, -0.1));
    for (var i = 0.1; i <= 0.9; i += 0.1) {
      arr.push(this.colorLuminance(primary_color, i));
    }
    return arr;
  }

  getModifiedCssText(txt) {
    for (var k = 0; k < this.CHANGE_COLORS_FROM.length; k++) {
      //console.log("ESACPED REGEX: " + this.escapeRegExp(this.CHANGE_COLORS_FROM_RGB[k].replace(/\s/g, '\s*')))
      var regex = new RegExp(this.escapeRegExp(this.CHANGE_COLORS_FROM_RGB[k]), 'g');
      txt = txt.replace(regex, this.CHANGE_COLORS_TO[k]);
    }
    return txt;
  }

  escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  }

  colorLuminance(hex, lum) {
    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    var rgb = "#",
        c,
        i;
    for (i = 0; i < 3; i++) {
      c = parseInt(hex.substr(i * 2, 2), 16);
      if (lum < 0) {
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
      } else {
        c = Math.round(Math.min(Math.max(0, c + (255 - c) * lum), 255)).toString(16);
      }
      rgb += ("00" + c).substr(c.length);
    }

    return rgb;
  }

  toRgbFunction(hex) {
    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    // convert to decimal
    var func = "rgb(",
        i;
    for (i = 0; i < 3; i++) {
      if (i > 0) func += ', ';
      func += parseInt(hex.substr(i * 2, 2), 16);
    }

    func += ')';

    return func;
  }
}

// add any missing base props with a default value
export function addDefaultThemeProps(props) {
  let np = JSON.parse(JSON.stringify(props));
  for (let key in DefaultTheme) {
    if (np[key] == null) {
      np[key] = DefaultTheme[key];
    }
  }
  return np;
}

// convert theme props saved with an older version of the IAD to new format
export function toLatestThemePropsVersion(props) {
  let np = {};
  for (let key in props) {
    if (key.startsWith('audienceDisplay-')) {
      let pstr = key.slice(16);
      let newkey = 'audienceDisplay' + pstr.charAt(0).toUpperCase() + pstr.slice(1);
      if (newkey === 'audienceDisplayColor') {
        newkey = 'audienceDisplayTextColor';
      }
      np[newkey] = props[key];
    } else {
      np[key] = props[key];
    }
  }
  return np;
}

export const DefaultTheme = {
  'audienceDisplayTextColor': '#2c3e50',
  'audienceDisplayBackgroundColor': '#005276',
  'audienceDisplayResultsAndSelectionsColor': '#00838D',
  'audienceDisplayLogoRes': undefined,
  'audienceDisplayTextLuminance': 'light'
};


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/theme.js
// module id = mUMr
// module chunks = 1 2 3 4 5 6